<template>
  <b-sidebar
    id="sidebar-update-apply-document"
    ref="sidebarUpdateApplyDocument"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Update') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />

      </div>
      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <validation-observer ref="examResultAdd">
          <!-- direction mark -->
          <b-form-group
            v-if="isFirstQuarter"
            :label="$t('Direction mark')"
            label-for="direction_mark"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Direction mark')"
              rules="required|min_value:0|max_value:100"
            >
              <b-form-input
                id="direction_mark"
                v-model="examResult.direction_mark"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group
            v-if="isFirstQuarter"
            :label="$t('Is certificate')"
            label-for="is_certificate"
          >
            <b-form-checkbox
              id="is_certificate"
              v-model="examResult.is_certificate"
              switch
            />
          </b-form-group>
          <b-form-group
            v-if="isFirstQuarter"
            :label="$t('English Mark')"
            label-for="english_mark"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('English Mark')"
              rules="required|min_value:0|max_value:100"
            >
              <b-form-input
                id="english_mark"
                v-model="examResult.english_mark"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group
            :label="$t('Result')"
            label-for="is_accepted"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Result')"
              rules="required"
            >
              <v-select
                id="is_accepted"
                v-model="examResult.is_accepted"
                :reduce="(option) => option.id"
                :options="examResultStatuses"
                :get-option-label="(option) => $langName(option.name)"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </validation-observer>

        <div v-if="examResult.is_accepted === 200">
          <b-form-group
            :label="$t('Research Advisor')"
            label-for="advisor"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Research Advisor')"
              :rules="isDc() ? '' : 'required'"
            >
              <v-select
                v-model="examResult.advisor"
                :options="advisorList"
                :reduce="(option) => option.id"
                :get-option-label="(option) => option.full_name"
                @search="fetchAdvisor"
                @input="inputAdvisor"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <!-- Scientific work name -->
          <b-form-group
            :label="$t('Scientific work name')"
            label-for="scientific_work_name"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Scientific work name')"
              :rules="isDc() ? '' : 'required'"
            >
              <b-form-input
                id="scientific_work_name"
                v-model="examResult.scientific_work_name"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </div>
        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
            @click="submit(hide)"
          >
            {{ applyDocument.id ? $t('Update') : $t('Create') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>
<script>
import {
  BButton, BForm, BFormCheckbox, BFormGroup, BFormInput, BSidebar,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { localize, ValidationObserver, ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'
import { required } from '@/libs/validations/validations'

export default {
  name: 'ApplyDocumentComponent',
  directives: {
    Ripple,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    BSidebar,
    BButton,
    BFormGroup,
    BFormInput,
    BForm,
    BFormCheckbox,
    vSelect,
  },
  props: {
    moduleNameApplyDocument: {
      type: String,
      default: 'applyDocument',
    },
    moduleNameUpdate: {
      type: String,
      default: 'examResult',
    },
    isFirstQuarter: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      required,
      base64: null,
      advisors: [],
    }
  },
  computed: {
    applyDocument() {
      return this.$store.state[this.moduleNameApplyDocument].applyDocument
    },
    examResult() {
      return this.$store.state[this.moduleNameUpdate].examResult
    },
    examResultStatuses() {
      return this.$store.state.staticModule.examResultStatusesFirst
    },
    advisorList() {
      if (this.selectedAdvisor && !this.advisors.find(x => x.id === this.selectedAdvisor.id)) {
        return [this.selectedAdvisor, ...this.advisors]
      }
      return this.advisors
    },
  },
  created() {
    localize(this.$i18n.locale)
  },
  methods: {
    isDc() {
      return this.$store.getters['staticModule/isDc'](this.applyDocument.dc_type)
    },
    clear(hide) {
      this.$store.commit(`${this.moduleNameUpdate}/UPLOAD_EXAM_RESULT`)
      this.$store.commit(`${this.moduleNameApplyDocument}/SET`, {})
      this.$refs.examResultAdd.reset()
      hide()
    },
    loadData() {
      this.examResult.scientific_work_name = this.applyDocument.scientific_work_name
      if (this.applyDocument.advisor) {
        this.examResult.advisor = this.applyDocument.advisor?.id
        this.selectedAdvisor = this.applyDocument.advisor
      }
      this.fetchAdvisor('', () => {})
    },
    handleFile(e) {
      // eslint-disable-next-line prefer-destructuring
      this.base64 = e.target.files[0]
    },
    submit(hide) {
      this.$refs.examResultAdd.validate().then(success => {
        if (success) {
          this.examResult.base64 = this.base64
          this.$removeSwal(this, this.examResult, `${this.moduleNameUpdate}/create`, () => {
            this.$emit('refetchData')
          }, {
            confirmButtonText: 'Yes, send it!',
            successTitle: 'Send!',
            successText: 'Your file has been sent.',
            errorText: 'Your file has not been sent.',
          })
          hide()
        }
      })
    },
    fetchAdvisor(search, loading) {
      loading(true)
      this.$store.dispatch('staticModule/researchAdvisors', { search }).then(res => {
        this.advisors = res
        loading(false)
      })
    },
    inputAdvisor(id) {
      this.selectedAdvisor = this.advisors.find(x => x.id === id)
    },
  },
}
</script>
